import { observable, action } from 'mobx'
import RequestService from '../../services/request.service'
import SessionService from '../../core/session'
import { message } from 'antd'

interface IListResponse {
  list: any[]
  current: number
  total: number
  size: number
}

const sessionService = SessionService.Instance()

export default abstract class BaseListModel {
  apiUrl: string
  @observable listResponse: IListResponse = {
    list: [],
    current: 0,
    total: 0,
    size: 10,
  }
  @observable listError = {
    state: 'default',
    msg: 'success',
  }

  @action
  changePage(target: any) {
    return this.loadPageList({
      pn: target,
    })
  }

  @action
  reloadCurrentPage() {
    return this.loadPageList({
      pn: this.listResponse.current,
    })
  }

  @action
  loadPageList(condition?: any) {
    this.listError = {
      state: 'loading',
      msg: '',
    }
    const queryCondition = condition || {}
    if (!queryCondition['pn']) {
      queryCondition['pn'] = 1
    }

    const httpClient = RequestService.Instance().getClient(
      sessionService.getToken()
    )
    return httpClient
      .get(this.apiUrl, { params: queryCondition })
      .then((response: any) => {
        const responseData = response.data
        if (responseData.status) {
          throw new Error(responseData['msg'])
        }
        this.listResponse = {
          ...this.listResponse,
          ...responseData.data,
        }

        if (queryCondition['pn']) {
          this.listResponse['current'] = queryCondition['pn']
        }

        this.listError = {
          state: 'success',
          msg: 'success',
        }
      })
      .catch((err: Error) => {
        message.warning(err.message)
        this.listError = {
          state: 'error',
          msg: err.message,
        }
      })
  }
}
